import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";

import { getInitialReleasesManagerState, IReleaseRow, IReleasesManagerFilter, IReleasesManagerFilterData, IReleasesManagerState } from "./ReleasesManager.state";

const initialState = getInitialReleasesManagerState();

export const releasesManager = createSlice({
  name: "releasesManager",
  initialState: initialState,
  reducers: {
    initialize: state => {
      return { ...state, isLoading: true };
    },
    loadingFailed: (state, action: PayloadAction<INotification>) => {
      state.isLoading = false;
      state.notifications.push(action.payload);
      return state;
    },
    initializeCompleted: (state, action: PayloadAction<IReleasesManagerFilter>) => {
      return { ...state, isLoading: false, filter: action.payload };
    },
    search: actionProcessing.createWithClearNotification((state: IReleasesManagerState, action: PayloadAction<IReleasesManagerFilterData | undefined>) => {
      return { ...state, isLoading: true, filter: { ...state.filter, data: action.payload || state.filter.data } };
    }),
    searchCompleted: (state, action: PayloadAction<IReleaseRow[]>) => {
      return {
        ...state,
        isLoading: false,
        grid: { ...state.grid, gridData: action.payload, selected: undefined, isSearched: true }
      };
    }
  },
  extraReducers: getScreenExtraReducers<IReleasesManagerState>("notifications", initialState)
});
